// sync with "increaseBudget opcode cost" e2e tests
export const increaseBudgetBaseCost = 24;
export const increaseBudgetIncrementCost = 23;
/**
 * MBR of a whitelist box holding ONE entry: 2500 + 400 * (1 prefix + 32 address key
 * + 2 array length + 9 per (uint8,uint64) entry) microAlgo. The SDK pays this per
 * account on addWhitelist; when appending to an existing box only
 * WHITELIST_ENTRY_MBR is actually consumed - the surplus stays in the app balance
 * and is admin-withdrawable.
 */
export const WHITELIST_BOX_MBR = 20100n;
/** Additional MBR consumed per whitelist entry appended to an existing box */
export const WHITELIST_ENTRY_MBR = 3600n;
/**
 * MBR of a claimedTokens box holding ONE id: 2500 + 400 * (1 prefix + 32 address key
 * + 2 array length + 1 uint8) microAlgo. Paid per token claim (appends cost only
 * TOKEN_CLAIM_ENTRY_MBR; surplus stays in the app balance).
 */
export const TOKEN_CLAIM_BOX_MBR = 16900n;
/** Additional MBR consumed per claimed-token id appended to an existing box */
export const TOKEN_CLAIM_ENTRY_MBR = 400n;
/** MBR of an asset config box: key is 'a' + 8-byte ASA id, value is (uint8, uint64 claimCount, uint64 endTime, string prefix) */
export function assetConfigBoxMbr(claimTokenPrefixLength) {
    // 2500 + 400 * (9 key + 1 uint8 + 8 uint64 claimCount + 8 uint64 endTime + 2 string offset + 2 string length + prefix)
    return 2500n + 400n * BigInt(9 + 1 + 8 + 8 + 2 + 2 + claimTokenPrefixLength);
}
/** Default domain separation prefix for claim tokens: token = ed25519_sign(prefix + claimer pubkey) */
export const CLAIM_TOKEN_PREFIX = "7";
/** ALGO MBR consumed by the app account when opting into one asset */
export const ASSET_OPTIN_MBR = 100000n;
/**
 * Max whitelist accounts per app call. Each account costs one box reference, the
 * asset config box costs one more, and an app call carries at most 8 box references.
 */
export const WHITELIST_CHUNK_SIZE = 7;
/**
 * Max asset configs per deleteAssetConfigs app call: each config costs one box
 * reference and an app call carries at most 8 box references.
 */
export const ASSET_CONFIG_CHUNK_SIZE = 8;
/**
 * Max accounts per deleteBoxes app call. deleteBoxes touches BOTH the whitelist and
 * the claimedTokens box for each account (each is referenced even when absent, to test
 * existence), so that's 2 box references per account against the 8-per-app-call limit.
 */
export const DELETE_BOXES_CHUNK_SIZE = 4;
/**
 * Max accounts per logClaimsRemaining app call: bounded by the 2048-byte app args
 * limit (63 addresses x 32 bytes + ABI overhead).
 */
export const LOG_CLAIMS_PER_CALL = 63;
/** Max accounts per simulated logClaimsRemaining group (spread over multiple app calls) */
export const LOG_CLAIMS_PER_GROUP = 128;
/** Default send params: auto-populate box/asset/account references via simulate */
export const SEND_PARAMS = { populateAppCallResources: true };
